// extracted by mini-css-extract-plugin
module.exports = {"root":"DrivingSlipQuestionnaireNode_root__2drZH","expandIconWrapper":"DrivingSlipQuestionnaireNode_expandIconWrapper__-hT5c","isOpen":"DrivingSlipQuestionnaireNode_isOpen__1IWqD"};